import store from '@/store'
import axios from '@/axios'

store.subscribe((mutation) => {
    switch (mutation.type) {
        case 'auth/SET_TOKEN':
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + mutation.payload
            localStorage.setItem('token', mutation.payload)
    }
})